module.exports = __webpack_public_path__ + "static/media/class_job_032.e8b18311.svg";